import { render, staticRenderFns } from "./Carrier.vue?vue&type=template&id=c860c056&scoped=true"
import script from "./Carrier.vue?vue&type=script&lang=js"
export * from "./Carrier.vue?vue&type=script&lang=js"
import style0 from "./Carrier.vue?vue&type=style&index=0&id=c860c056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c860c056",
  null
  
)

export default component.exports